function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Poland Icon");

var _ref3 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "55.3,60.4 30.3,56.8 3.1,40.9 3.1,28.7 0.7,9.6 30.5,0.6 31.7,4.4 5.1,12.4 7.1,28.6 7.1,38.6      31.6,52.9 51.3,55.8 51.3,50.9 59.5,41.3 53.2,28.6 56.8,21.4 53.1,12.5 25.8,12.5 25.8,8.5 55.8,8.5 61.2,21.5 57.7,28.6      64.3,41.8 55.3,52.4 "
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32.4,44.5l-1.1-0.8c-0.4-0.3-9.4-6.6-9.4-14.8c0-6,4.7-10.8,10.5-10.8c5.8,0,10.5,4.8,10.5,10.8     c0,8.3-9,14.6-9.4,14.8L32.4,44.5z M32.4,22.1c-3.6,0-6.5,3.1-6.5,6.8c0,4.4,4,8.6,6.5,10.7c2.1-1.8,6.5-6,6.5-10.7     C38.9,25.1,36,22.1,32.4,22.1z"
});

var SvgPoland = function SvgPoland(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 65 61",
    fill: "#00dacc",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPoland, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/poland.accd331c.svg";
export { ForwardRef as ReactComponent };